<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="receipt-plus"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_8193" data-name="Path 8193" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_8194"
      data-name="Path 8194"
      d="M16,7H8m3,4H8m1,4H8m9,7a5,5,0,0,1-5-5,5.077,5.077,0,0,1,5-5,5,5,0,0,1,0,10"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8195"
      data-name="Path 8195"
      d="M20,13.022V4a1,1,0,0,0-1-1H5A1,1,0,0,0,4,4V19.191a.5.5,0,0,0,.724.447l1.943-.972L9.11,19.888a.5.5,0,0,0,.447,0L12,18.667l.362.181"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8196"
      data-name="Path 8196"
      d="M13.555,11.223,11.61,13.168,10.444,12"
      transform="translate(5 5)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
